"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const native_base_1 = require("native-base");
const ModalSobreDiscount = ({ onAccept, product, ...rest }) => {
    const toast = (0, native_base_1.useToast)();
    const [discount, setDiscount] = React.useState("");
    const onAcceptPressed = () => {
        console.log("product:", product);
        if (isNaN(Number(discount))) {
            return;
        }
        if (Number(discount) > (product?.maxSobreDesc ?? 0)) {
            toast.show({ description: `Máximo de ${product?.maxSobreDesc ?? ""}%` });
            return;
        }
        onAccept(discount, product);
        setDiscount("");
    };
    const onChangeAddress = (text) => {
        if (isNaN(Number(text))) {
            setDiscount(old => old);
            return;
        }
        else {
            setDiscount(text);
        }
    };
    return (<native_base_1.Modal {...rest} ml="0">
			<native_base_1.Modal.Content>
				<native_base_1.Modal.CloseButton />
				<native_base_1.Modal.Body>
					<native_base_1.VStack>
						<native_base_1.Text mb={10} textAlign="center">
							Ingrese el descuento
						</native_base_1.Text>
						<native_base_1.Center>
							<native_base_1.Input value={discount} onChangeText={onChangeAddress} mt={10} mb={1} width={150} keyboardType="numeric"/>
						</native_base_1.Center>
					</native_base_1.VStack>
				</native_base_1.Modal.Body>
				<native_base_1.Modal.Footer>
					<native_base_1.Button onPress={onAcceptPressed}>Aceptar</native_base_1.Button>
				</native_base_1.Modal.Footer>
			</native_base_1.Modal.Content>
		</native_base_1.Modal>);
};
exports.default = ModalSobreDiscount;
